import React from 'react';
import '../../resources/styles/scss/components/common/AwsDisclaimer.css';
export default () => {
  return (
    <div className="disclaimer-box">
      <div className="disclaimer-header">
        <span>AWS DISCLAIMER</span>
      </div>

      <div className="text-align-centre">
        <p>
          This disclaimer applies to the APG Library and all other documents, information, data, and
          responses (written or verbal) provided by Amazon Web Services, Inc. ("AWS") in connection
          with the APG Library and your use (“You”) of the APG Library services.
        </p>
        <p>
          All use of AWS Services will be governed by the AWS Customer Agreement available at
          http://aws.amazon.com/agreement/ (or other written agreement between the parties governing
          the use of AWS Services ) (the "Agreement"). Pricing information (if any) provided in this
          APG Library is subject to change in accordance with the Agreement. Nothing in the APG
          Library will modify or supplement the terms of the Agreement or any Non-Disclosure
          Agreement ("NDA") between AWS and You.
        </p>
        <p>
          Content that has current visibility of “AWS” is AWS Confidential Information. Use of this
          content is governed by the confidentiality agreements AWS has with its employees,
          customers, and Partners. This content can be shared with customers and Partners that are
          under NDA.
        </p>
      </div>
    </div>
  );
};
